<template>
    <div>
        <v-card flat class="pa-1 bg-white shadow-md rounded-md">
            <v-card-title class="flex justify-center flex-col">
                <h5>Selecione um perfil para login:</h5>
            </v-card-title>
            <v-divider class="mx-10"></v-divider>
            <v-container fluid class="fill-height space-y-2">
                <v-sheet class="overflow-y-auto w-full d-flex flex-col gap-2 h-auto mb-3">
                    <v-list  max-height="200px">
                        <v-list-item-group>
                            <v-list-item v-for="(profile, index) in profileUserUnities" :key="index.id" class="rounded-[1em] border border-solid mb-2 border-gray-200 bg-grey-300" style="display: flex; align-items: center; gap: 12px;">
                                <v-list-item-icon style="flex-shrink: 0; min-width: auto;">
                                    <v-icon
                                        :color="itemSelected === profile ? 'green darken-3' : '#0000008a'"
                                        @click="selectItem(profile)"
                                        class="cursor-pointer"
                                    >
                                        {{ itemSelected === profile ? 'mdi-checkbox-marked-circle' : 'mdi-checkbox-blank-circle-outline' }}
                                    </v-icon>
                                </v-list-item-icon>

                                <v-list-item-content @click="selectItem(profile)" class="cursor-pointer" style="flex: 1; min-width: 0;">
                                    <v-list-item-title class="text-sm truncate">{{ profile.profile.name }}</v-list-item-title><br>
                                    <small class="text-xs font-bold">{{ profile.unity.hospital }}</small>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-sheet>
                
                <v-row dense >
                    <v-text-field
                        ref="passwordField"
                        v-model="password" 
                        class="rounded-lg"
                        color="green darken-3"
                        placeholder="******"
                        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPass ? 'text' : 'password'"
                        :disabled="itemSelected == null"
                        :rules="formValidate.password"
                        @click:append="showPass = !showPass"
                        outlined
                        dense>
                        <template v-slot:label>
                            Senha de Login <span style="color: red;">*</span> 
                        </template>
                    </v-text-field>
                </v-row>

                <v-row class="space-x-2" dense align="center" justify="center">
                    <v-btn  
                        @click="login()" 
                        color="green darken-3"  
                        class="rounded-lg mb-2 mb-sm-0 mr-2" 
                        :loading="isLoading" 
                        :disabled="itemSelected == null"
                    >
                        <span style="color: white">Trocar de perfil</span> 
                    </v-btn>
                    <v-btn  
                        @click="$emit('closeModal', true), password = ''" 
                        class="rounded-lg"
                    >
                        Cancelar
                    </v-btn>
                </v-row>
            </v-container>
        </v-card>

        <v-dialog width="400px" v-model="changeRealized" hide-overlay persistent>
            <v-card flat>
                <v-card-title class="d-flex justify-center">
                    Troca de Perfil Realizada!
                </v-card-title>
                
                <v-container fluid>
                    <span class="d-flex justify-center text-sm p-2 font-light">Você agora está logado como:</span>
                    <v-row dense>
                        <v-col class="d-flex justify-center" cols="12">
                            <v-alert
                                class="w-2/3"
                                icon="mdi-checkbox-marked-circle"
                                color="green darken-3"
                                dense 
                                text
                            >
                                {{ newProfile }}<br>
                                <small>{{ newSector }}</small>
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-container>

                <v-container fluid class="d-flex justify-center">
                    <v-btn
                        depressed
                        color="green darken-3"
                        rounded
                        small
                        class="w-1/2"
                        @click="changeRealized = false"
                    >
                        <span style="color: white">OK</span>
                    </v-btn>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>
<script> 
import { mapActions, mapMutations } from "vuex";
import LoginService from "@/service/auth/LoginService";
import setAuthData from "@/service/auth/AuthService"; 
import { AbilityMixin } from "@/mixins/ability.mixin";
export default {
    mixins: [AbilityMixin],
    data: () => ({
        changeRealized: false,
        userData: {},
        user: {
            cpf: '',
            password: ''
        },
        isLoading: false,
        itemSelected: null,
        password: '',
        showPass: false,
        newSector: "",
        newProfile: "",
        formValidate: {
            password: [
                v => !!v || 'Senha é obrigatória',
                v => (v && v.length >= 1) || 'Senha é obrigatória'
            ]
        }
    }),

    computed: {
        currentUser() {
            return this.getCurrentSession;
        },

        profileUserUnities() {
            return this.profiles
                .map((profile) =>
                    profile.profile_user_unities.map((item) => ({
                        ...item,
                        unity: profile.unity,
                    }))
                )
                .flat()
                .filter(item => item.profile_id !== this.currentUser.profile_id);
        },
    },

    props: {
        profiles: {
            type: Array,
        },
    },

    methods: {
        ...mapActions('patient', ['changeCurrentUser']),
        ...mapMutations(['setSessionData']),

        async login() {
            if (!this.$refs.passwordField.validate()) {
                return;
            }

            this.isLoading = true;

            let userData = {
                cpf: this.currentUser.cpf,
                password: this.password,
                profile_id: parseInt(this.itemSelected.profile_id),
                unity_id: parseInt(this.itemSelected.unity.id)
            };

            try {
                await LoginService.login(userData); 

                const authMeData = await setAuthData();

                const updatedUser = this.currentUser
               
                await this.changeCurrentUser(updatedUser);
                this.setSessionData(authMeData); 

                this.isLoading = false;
                this.newProfile = authMeData.profile;
                this.newSector = authMeData.unity.hospital;

                this.password = '';
                this.$refs.passwordField.resetValidation();
                this.$emit('profileChanged', updatedUser);
                this.$emit('closeModal', true);
                this.changeRealized = true;

                setTimeout(() => {
                    if(this.$router.history.current.path != '/dashboard'){
                        this.$router.push({
                            name: "Dashboard",
                        });
                    }
                }, 1000);

            } catch (error) {
                this.isLoading = false;
                this.$swal({
                    icon: "error",
                    title: "Erro ao trocar de perfil",
                    html: error.response?.data?.details || "Preencha os dados corretamente!",
                    width: '350px',
                    heightAuto: false,
                    showConfirmButton: true,
                    confirmButtonColor: "#1976d2",
                    confirmButtonText: "Fechar",
                    timer: 3000
                });
            }
        },

        selectItem(profile) { 
            this.itemSelected = profile;
        }, 
    },
}
</script> 